import { $, addAction, LAYOUT } from '@situation/setdesign.util';

addAction(LAYOUT, () => {
    $('.header-nav__dropdowns')
        .children()
        .each((index, containerEl) => {
            const $container = $(containerEl);
            const $items = $container.find('.sub-nav__item');
            if ($items.length) {
                // Temporarily add measuring class to remove constraints
                $container.addClass('header-nav__measuring');
                const dropdownWidth = Math.max(
                    0,
                    ...$items
                        .find('.sub-nav__link')
                        .get()
                        .map((link, idx) => {
                            const { width } = link.getBoundingClientRect();
                            return idx === 0 ? width + 50 : width;
                        }),
                );
                $container.removeClass('header-nav__measuring');
                $container.css('--dropdown-width', `${Math.ceil(dropdownWidth)}px`);
            }
        });
});
